//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    skuPrefix: { type: String, required: true },
    frameType: { type: String, default: null },
    productDetails: { type: Object, default: null }
  },
  data () {
    return {
      comparison: 'no-select',
      products: {
        'velans-tf': 'Velans™ TF',
        'velans-ff': 'Velans™ FF',
        'vulcans-tf': 'Vulcans™ TF',
        'vulcans-ff': 'Vulcans™ FF',
        'airas-zf': 'Airas™ ZF',
        'airas-bf': 'Airas™ BF'
      },
      stats: {
        'lens-shape': {
          'vulcans-tf': 'cylindrical',
          'vulcans-ff': 'cylindrical',
          'velans-tf': 'spherical',
          'velans-ff': 'spherical',
          'airas-zf': 'cylindrical',
          'airas-bf': 'cylindrical'
        },
        'frame-size': {
          'vulcans-tf': ['m', 'l'],
          'vulcans-ff': ['m', 'l'],
          'velans-tf': ['s', 'm'],
          'velans-ff': ['s', 'm'],
          'airas-zf': ['m', 'l'],
          'airas-bf': ['m', 'l']
        },
        peripheral: {
          'vulcans-tf': 'unobstructed',
          'vulcans-ff': 'extended',
          'velans-tf': 'unobstructed',
          'velans-ff': 'extended',
          'airas-zf': 'unobstructed',
          'airas-bf': 'extended'
        },
        wind: {
          'vulcans-tf': 'excellent',
          'vulcans-ff': 'complete',
          'velans-tf': 'excellent',
          'velans-ff': 'complete',
          'airas-zf': 'excellent',
          'airas-bf': 'complete'
        },
        weight: {
          'vulcans-tf': '31g',
          'vulcans-ff': '34g',
          'velans-tf': '29g',
          'velans-ff': '32g',
          'airas-zf': '27g',
          'airas-bf': '30g'
        },
        'lens-change-time': {
          'vulcans-tf': 'Yes, 15 seconds',
          'vulcans-ff': 'Yes, 25 seconds',
          'velans-tf': 'Yes, 15 seconds',
          'velans-ff': 'Yes, 25 seconds',
          'airas-zf': 'Yes, 15 seconds',
          'airas-bf': 'Yes, 20 seconds'
        },
        'best-for': {
          'vulcans-tf': 'Road Cycling, Running',
          'vulcans-ff': 'Road Cycling, Mountain Biking',
          'velans-tf': 'Road Cycling, Running',
          'velans-ff': 'Road Cycling, Mountain Biking',
          'airas-zf': 'Road Cycling, Running',
          'airas-bf': 'Road Cycling, Mountain Biking'
        }
      },
      hidden: {
        'frame-size': [
          ['vulcans-tf', 'vulcans-ff'],
          ['velans-tf', 'velans-ff'],
          ['airas-zf', 'airas-bf']
        ],
        wind: [
          ['vulcans-tf', 'velans-tf'],
          ['vulcans-tf', 'no-select'],
          ['no-select', 'velans-tf']
        ],
        peripheral: [
          ['velans-ff', 'vulcans-ff'],
          ['vulcans-ff', 'no-select'],
          ['no-select', 'velans-ff']
        ]
      }
    }
  },
  computed: {
    currentProduct () { return `${this.skuPrefix}-${this.frameType}` },
    comparisonProductName () {
      return this.comparison.replace('-', ' ')
    },
    comparisonProducts () {
      return Object.entries(this.products).filter(([sku, name]) => sku !== this.currentProduct)
    }
  },
  watch: {
    currentProduct (val) {
      if (this.comparisonProducts.find(([sku, _]) => sku === this.comparison)) return
      this.comparison = this.comparisonProducts[0][0]
    }
  },
  methods: {
    getStat (stat) {
      return (this.stats[stat] || {})[this.currentProduct]
    },
    getComparisonStat (stat) {
      return (this.stats[stat] || {})[this.comparison]
    },
    getClassLHS (statName, value) {
      const stat = this.getStat(statName)
      const comparisonStat = this.getComparisonStat(statName)
      return {
        scale: true,
        'active-left': stat === value || (Array.isArray(stat) && stat.includes(value)),
        'active-right': comparisonStat === value || (Array.isArray(comparisonStat) && comparisonStat.includes(value))
      }
    },
    getClassRHS (statName, value) {
      const comparisonStat = this.getComparisonStat(statName)
      return {
        scale: true,
        active: comparisonStat === value || (Array.isArray(comparisonStat) && comparisonStat.includes(value))
      }
    },
    isHidden (stat) {
      return (this.hidden[stat] || []).some(
        hidden => hidden.includes(this.currentProduct) && hidden.includes(this.comparison)
      )
    }
  }
}
